import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "../assets/styles/home.css";
import ChatbotButton from "../components/common/ChatbotButton";
import Footer from "../components/layout/Footer";

import { LayoutDashboard, Compass, Users } from "lucide-react";

import LatestActivitiesSection from "../components/ui/LatestActivities";
import { AuthContext } from "../context/AuthContext";
import FullPageLoader from "../components/ui/fullPageLoader.js";
import { userRoles } from "../App.js";
import { resent5_ActivitiesAPI } from "../services/activityService.js";
import TopFive from "../components/TopFive.jsx";
import WhyCampusPulse from "../components/WhyCampusPulse.jsx";
import DiscoverCampus from "../components/DiscoverCampus.jsx";
import NotificationPrompt from "../components/NotificationPrompt.jsx";

export default function Home() {
  const { loading, user } = useContext(AuthContext);

  const navigate = useNavigate();
  // const [index, setIndex] = useState(0);
  const [loadingApi, setLoadingApi] = useState(false);
  const [resentActivities, setResent5_Activities] = useState([]);
  // const handleSelect = (selectedIndex) => {
  //   setIndex(selectedIndex);
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingApi(true);
        const activitiesApi = await resent5_ActivitiesAPI();
        setResent5_Activities(activitiesApi.activities);
        setLoadingApi(false);
      } catch (error) {
        setLoadingApi(false);
        console.error("Error fetching activities:", error);
      }
    };

    fetchData();
  }, []);

  // const slides = [
  //   {
  //     img: "/hero/sport.png",
  //     title: "Sports Activities",
  //     desc: "Join tournaments, stay active, and make friends through teamwork.",
  //     category: "sports",
  //   },
  //   {
  //     img: "/hero/academic.png",
  //     title: "Academic Events",
  //     desc: "Sharpen your skills and showcase your academic excellence.",
  //     category: "academic",
  //   },
  //   {
  //     img: "/hero/fun.png",
  //     title: "Entertainment Events",
  //     desc: "Unwind with concerts, shows, and fun gatherings!",
  //     category: "entertainment",
  //   },
  //   {
  //     img: "/hero/competition.png",
  //     title: "Competitions",
  //     desc: "Challenge yourself and compete to win exciting prizes.",
  //     category: "competitions",
  //   },
  // ];

  if (loading) {
    return <FullPageLoader loadingName="Loading user..." />;
  }

  const handleRoutDashboard = function () {
    if (user?.role === userRoles.admin) {
      navigate("/admin/dashboard");
    } else if (user?.role === userRoles.supervisor) {
      navigate("/supervisor-dashboard");
    } else {
      navigate("/student-dashboard");
    }
  };

  return (
    <div className="home-root">
      {/* HERO SECTION */}
      <section
        className="hero-section"
        style={{ backgroundImage: "url('/hero/nub.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <Container style={{ position: "relative", zIndex: 2 }}>
          <motion.h1
            className="fw-bold display-4 text-center text-white"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Welcome to <br className="d-md-none" />
            <motion.span
              className="brand-glass ms-md-2"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
            >
              CampusPulse
            </motion.span>
          </motion.h1>

          <motion.p
            className="fs-5 mt-4 mb-5 text-light opacity-75 mx-auto"
            style={{ maxWidth: "600px" }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Your gateway to university life — discover, join, and thrive!
          </motion.p>

          <motion.div
            className="d-flex justify-content-center gap-3 flex-wrap mt-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            {user?.role !== userRoles.externalorganizer &&
              user !== undefined && (
                <>
                  <button
                    className="btn-premium primary"
                    onClick={() => navigate("/activities/categories")}
                  >
                    <Compass size={20} className="me-2" />
                    Explore Activities
                  </button>

                  <button
                    className="btn-premium secondary"
                    onClick={handleRoutDashboard}
                  >
                    <LayoutDashboard size={20} className="me-2" />
                    Dashboard
                  </button>
                </>
              )}

            <button
              className="btn-premium outline"
              onClick={() => navigate("/our-team")}
            >
              <Users size={20} className="me-2" />
              Our Team
            </button>
          </motion.div>

          {/* 👥 Top 5 */}
          <div className="mt-5 pt-4">
            <TopFive currentUserId={user?._id} />
          </div>
        </Container>
      </section>

      {/* 🔍 QR SECTION */}
      {/* <section className="qr-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-5 mb-md-0 text-center">
              <motion.div
                className="qr-card-wrapper"
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <div className="qr-card">
                  <img src="/QR/qr-code.png" alt="QR" className="qr-image" />
                  <motion.div
                    className="qr-scan-text"
                    animate={{ y: [0, -5, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                      ease: "easeInOut",
                    }}
                  >
                    Scan & Go
                  </motion.div>
                </div>
                <div className="qr-card-glow"></div>
              </motion.div>
            </Col>

            <Col md={6}>
              <motion.div
                className="qr-content"
                initial={{ x: 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <h2 className="qr-title">Instant Access with QR Code</h2>
                <p className="qr-text">
                  Share the web app instantly with others. Just scan the QR code
                  and open the same page on any device in seconds. No downloads
                  required.
                </p>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* 🔍 QR SECTION */}
      <section className="qr-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-5 mb-md-0 text-center">
              <motion.div
                className="qr-card-wrapper"
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <div className="qr-card">
                  <img src="/QR/qr-code.png" alt="QR" className="qr-image" />
                  <motion.div
                    className="qr-scan-text text-center mt-3"
                    animate={{ y: [0, -5, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 2,
                      ease: "easeInOut",
                    }}
                  >
                    {/* النص تحت الـ QR */}
                    <div
                      dir="rtl"
                      className="fw-bold"
                      style={{ fontSize: "1.2rem", color: "#fff" }}
                    >
                      امسح وانطلق
                    </div>
                    <div
                      dir="ltr"
                      style={{
                        fontSize: "0.85rem",
                        opacity: 0.7,
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        color: "#fff",
                      }}
                    >
                      Scan & Go
                    </div>
                  </motion.div>
                </div>
                {/* Glow effect behind the card */}
                <div className="qr-card-glow"></div>
              </motion.div>
            </Col>

            <Col md={6}>
              <motion.div
                className="qr-content"
                initial={{ x: 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                {/* Title Block - العنوان */}
                <div className="mb-4">
                  <h2
                    className="qr-title mb-1"
                    dir="rtl"
                    style={{
                      textAlign: "right",
                      fontWeight: "800",
                      color: "#fff",
                    }}
                  >
                    وصول فوري بالـ QR
                  </h2>
                  <h3
                    dir="ltr"
                    style={{
                      fontSize: "1.2rem",
                      opacity: 0.6,
                      fontWeight: "500",
                      textAlign: "left",
                      color: "#fff",
                    }}
                  >
                    Instant Access with QR Code
                  </h3>
                </div>

                {/* Description Block - الوصف جوه كارت جلاسمورفيزم */}
                <div
                  className="qr-text-container p-4 rounded-4 shadow-sm"
                  style={{
                    background: "rgba(255, 255, 255, 0.03)",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                    backdropFilter: "blur(12px)",
                  }}
                >
                  <p
                    className="qr-text mb-3"
                    dir="rtl"
                    style={{
                      textAlign: "right",
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      color: "#e2e8f0",
                    }}
                  >
                    شارك المنصة فوراً مع زملائك. امسح الكود وافتح نفس الصفحة على
                    أي جهاز في ثوانٍ. بدون أي تحميل.
                  </p>

                  {/* خط فاصل أنيق */}
                  <hr
                    style={{
                      borderColor: "rgba(255,255,255,0.1)",
                      margin: "1rem 0",
                    }}
                  />

                  <p
                    className="qr-text mb-0"
                    dir="ltr"
                    style={{
                      textAlign: "left",
                      opacity: 0.7,
                      fontSize: "0.95rem",
                      lineHeight: "1.5",
                      color: "#e2e8f0",
                    }}
                  >
                    Share the web app instantly with others. Just scan the QR
                    code and open the same page on any device in seconds. No
                    downloads required.
                  </p>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {user?.role !== userRoles.externalorganizer && user !== undefined && (
        <LatestActivitiesSection
          loadingApi={loadingApi}
          latestActivities={resentActivities}
        />
      )}

      <NotificationPrompt />

      {/* 🏃 ACTIVITIES SLIDER */}
      <DiscoverCampus />
      {/* 🌟 WHY CAMPUSPULSE */}
      <WhyCampusPulse />

      <Footer />
      <ChatbotButton />
    </div>
  );
}

// import React, { useContext, useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { Container, Row, Col, Carousel } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// // import {
// //   CalendarDays,
// //   Trophy,
// //   Bell,
// //   BarChart2,
// //   MessageSquare,
// //   Target,
// // } from "lucide-react";
// import "../assets/styles/home.css";
// import ChatbotButton from "../components/common/ChatbotButton";
// import Footer from "../components/layout/Footer";

// import {
//   LayoutDashboard,
//   Compass,
//   Users,
//   ChevronLeft,
//   ChevronRight,
// } from "lucide-react";

// import LatestActivitiesSection from "../components/ui/LatestActivities";
// import { AuthContext } from "../context/AuthContext";
// import FullPageLoader from "../components/ui/fullPageLoader.js";
// import { userRoles } from "../App.js";
// import { resent5_ActivitiesAPI } from "../services/activityService.js";
// import TopFive from "../components/TopFive.jsx";
// import WhyCampusPulse from "../components/WhyCampusPulse.jsx";

// export default function Home() {
//   const { loading, user } = useContext(AuthContext);

//   const navigate = useNavigate();
//   const [index, setIndex] = useState(0);
//   const [loadingApi, setLoadingApi] = useState(false);
//   const [resentActivities, setResent5_Activities] = useState([]);
//   const handleSelect = (selectedIndex) => {
//     setIndex(selectedIndex);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoadingApi(true);
//         const activitiesApi = await resent5_ActivitiesAPI();
//         setResent5_Activities(activitiesApi.activities);
//         setLoadingApi(false);
//       } catch (error) {
//         setLoadingApi(false);
//         console.error("Error fetching activities:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const slides = [
//     {
//       img: "/hero/sport.png",
//       title: "Sports Activities",
//       desc: "Join tournaments, stay active, and make friends through teamwork.",
//       category: "sports",
//     },
//     {
//       img: "/hero/academic.png",
//       title: "Academic Events",
//       desc: "Sharpen your skills and showcase your academic excellence.",
//       category: "academic",
//     },
//     {
//       img: "/hero/fun.png",
//       title: "Entertainment Events",
//       desc: "Unwind with concerts, shows, and fun gatherings!",
//       category: "entertainment",
//     },
//     {
//       img: "/hero/competition.png",
//       title: "Competitions",
//       desc: "Challenge yourself and compete to win exciting prizes.",
//       category: "competitions",
//     },
//   ];

//   if (loading) {
//     return <FullPageLoader loadingName="Loading user..." />;
//   }

//   const handleRoutDashboard = function () {
//     if (user?.role === userRoles.admin) {
//       navigate("/admin/dashboard");
//     } else if (user?.role === userRoles.supervisor) {
//       navigate("/supervisor-dashboard");
//     } else {
//       navigate("/student-dashboard");
//     }
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: "#f9fbff",
//         marginTop: "70px",
//         overflowX: "hidden",
//       }}
//     >
//       {/* HERO SECTION */}
//       <section
//         style={{
//           backgroundImage: `url('/hero/nub.jpg')`,
//           backgroundSize: "cover",
//           backgroundAttachment: "fixed",
//           backgroundPosition: "center",
//           color: "white",
//           textAlign: "center",
//           padding: "140px 20px 110px",
//           position: "relative",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             background:
//               "linear-gradient(to bottom right, rgba(0,0,60,0.7), rgba(0,0,80,0.4))",
//           }}
//         ></div>

//         <Container style={{ position: "relative", zIndex: 2 }}>
//           <motion.h1
//             className="fw-bold display-5 display-md-4 text-center"
//             initial={{ opacity: 0, y: 25 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.9 }}
//           >
//             Welcome to{" "}
//             <motion.span
//               className="brand-glass"
//               initial={{ opacity: 0, y: 15 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8, ease: "easeOut" }}
//             >
//               CampusPulse
//             </motion.span>
//           </motion.h1>

//           <motion.p
//             className="fs-6 fs-md-5 mt-3 mb-4 text-light"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.4 }}
//           >
//             Your gateway to university life — discover, join, and thrive!
//           </motion.p>

//           <motion.div
//             className="d-flex justify-content-center gap-3 flex-wrap mt-4"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
//           >
//             {user?.role !== userRoles.externalorganizer &&
//               user !== undefined && (
//                 <>
//                   <button
//                     className="btn btn-primary btn-lg px-4 py-2 rounded-pill shadow-sm d-flex align-items-center"
//                     onClick={() => navigate("/activities/categories")}
//                   >
//                     <Compass size={20} className="me-2" />
//                     Explore Activities
//                   </button>

//                   <button
//                     className="btn btn-outline-light btn-lg px-4 py-2 rounded-pill d-flex align-items-center ms-3"
//                     onClick={handleRoutDashboard}
//                   >
//                     <LayoutDashboard size={20} className="me-2" />
//                     Dashboard
//                   </button>
//                 </>
//               )}

//             <button
//               className="btn btn-outline-light btn-lg px-4 py-2 rounded-pill d-flex align-items-center"
//               onClick={() => navigate("/our-team")}
//             >
//               <Users size={20} className="me-2" />
//               Our Team
//             </button>
//           </motion.div>

//           {/* 👥 Top 5 */}
//           <TopFive currentUserId={user?._id} />
//         </Container>
//       </section>

//       {/* 🔍 QR SECTION */}
//       <section className="qr-section">
//         <Container>
//           <Row className="align-items-center">
//             <Col md={6} className="mb-4 mb-md-0 text-center">
//               <motion.div
//                 className="qr-card"
//                 initial={{ scale: 0.9, opacity: 0 }}
//                 whileInView={{ scale: 1, opacity: 1 }}
//                 transition={{ duration: 0.6 }}
//               >
//                 <img src="/QR/qr-code.png" alt="QR" className="qr-image" />

//                 <motion.div
//                   className="qr-scan-text"
//                   animate={{ y: [0, -6, 0] }}
//                   transition={{
//                     repeat: Infinity,
//                     duration: 2,
//                     ease: "easeInOut",
//                   }}
//                 >
//                   Scan & Go
//                 </motion.div>
//               </motion.div>
//             </Col>

//             <Col md={6}>
//               <motion.div
//                 className="qr-content"
//                 initial={{ x: 80, opacity: 0 }}
//                 whileInView={{ x: 0, opacity: 1 }}
//                 transition={{ duration: 0.8 }}
//               >
//                 <h2 className="qr-title">Instant Access with QR Code</h2>
//                 <p className="qr-text">
//                   Share the web app instantly with others. Just scan the QR code
//                   and open the same page on any device in seconds.
//                 </p>
//               </motion.div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {user?.role !== userRoles.externalorganizer && user !== undefined && (
//         <LatestActivitiesSection
//           loadingApi={loadingApi}
//           latestActivities={resentActivities}
//         />
//       )}

//       {/* 🏃 ACTIVITIES SLIDER */}
//       {user?.role !== userRoles.externalorganizer && user !== undefined && (
//         <section className="activities-section">
//           <Container>
//             <h2 className="activities-title">Discover Activities</h2>

//             <Carousel
//               activeIndex={index}
//               onSelect={handleSelect}
//               controls={false}
//               indicators={false}
//               interval={null}
//               touch={false}
//               fade
//             >
//               {slides.map((a, i) => (
//                 <Carousel.Item key={i}>
//                   <Row className="align-items-center justify-content-center px-3">
//                     {/* IMAGE */}
//                     <Col md={6} className="mb-4 mb-md-0">
//                       <div className="activities-img-wrap">
//                         <img
//                           src={a.img}
//                           alt={a.title}
//                           className="activities-img"
//                         />
//                       </div>
//                     </Col>

//                     {/* TEXT */}
//                     <Col md={5} className="activities-text">
//                       <h3>{a.title}</h3>
//                       <p>{a.desc}</p>
//                       <button
//                         className="activities-btn"
//                         onClick={() =>
//                           navigate(`/activities/categories/${a.category}`)
//                         }
//                       >
//                         Explore More
//                       </button>
//                     </Col>
//                   </Row>
//                 </Carousel.Item>
//               ))}
//             </Carousel>

//             {/* Controls */}
//             <div className="activities-controls">
//               <button
//                 onClick={() =>
//                   setIndex(index === 0 ? slides.length - 1 : index - 1)
//                 }
//               >
//                 <ChevronLeft size={22} />
//               </button>
//               <button
//                 onClick={() =>
//                   setIndex(index === slides.length - 1 ? 0 : index + 1)
//                 }
//               >
//                 <ChevronRight size={22} />
//               </button>
//             </div>

//             {/* Indicators */}
//             <div className="activities-indicators">
//               {slides.map((_, i) => (
//                 <span
//                   key={i}
//                   className={i === index ? "active" : ""}
//                   onClick={() => setIndex(i)}
//                 />
//               ))}
//             </div>
//           </Container>
//         </section>
//       )}

//       {/* 🌟 WHY CAMPUSPULSE */}
//       {/* <section className="why-section">
//         <Container>
//           <h2 className="why-title">
//             Why Choose <span>CampusPulse?</span>
//           </h2>

//           <Row className="g-4">
//             {[
//               {
//                 icon: <CalendarDays size={36} />,
//                 title: "Effortless Event Management",
//                 text: "Browse, join, and manage all your campus activities easily — everything organized in one smart platform.",
//               },
//               {
//                 icon: <Trophy size={36} />,
//                 title: "Top Student Recognition",
//                 text: "Track the top 5 most active students and encourage healthy competition through rewards and achievements.",
//               },
//               {
//                 icon: <Bell size={36} />,
//                 title: "Instant Updates",
//                 text: "Get notified instantly about upcoming events, changes, and registrations. Never miss an opportunity.",
//               },
//               {
//                 icon: <BarChart2 size={36} />,
//                 title: "Personal Dashboard",
//                 text: "All your participation data in one place — events, attendance, and stats organized clearly.",
//               },
//               {
//                 icon: <MessageSquare size={36} />,
//                 title: "AI Chat Support",
//                 text: "Smart assistant ready to answer questions and guide students and organizers efficiently.",
//               },
//               {
//                 icon: <Target size={36} />,
//                 title: "Boost Engagement",
//                 text: "Motivate students with rewards, challenges, and visibility of achievements.",
//               },
//             ].map((f, i) => (
//               <Col xs={12} sm={6} md={4} key={i}>
//                 <motion.div
//                   className="why-card"
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: i * 0.1 }}
//                   viewport={{ once: true }}
//                 >
//                   <div className="why-icon">{f.icon}</div>
//                   <h5>{f.title}</h5>
//                   <p>{f.text}</p>
//                 </motion.div>
//               </Col>
//             ))}
//           </Row>
//         </Container>
//       </section> */}
//       {/* 🌟 WHY CAMPUSPULSE */}
//       <WhyCampusPulse />

//       <Footer />
//       <ChatbotButton />
//     </div>
//   );
// }
